import { useState } from 'react'
import Button from '../components/Button'

export default function Settings() {
  const [settings, setSettings] = useState({
    apiUrl: 'https://api.example.com',
    autoSync: true,
    syncInterval: 30,
    darkMode: false,
    notifications: true,
  })

  const handleSave = () => {
    // TODO: 保存设置到后端
    alert('设置已保存')
  }

  return (
    <div className="space-y-4 md:space-y-6">
      {/* 页面标题 */}
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-gray-900">设置</h1>
        <p className="text-sm text-gray-500 mt-1">配置你的应用参数</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        {/* 主要设置 */}
        <div className="lg:col-span-2 space-y-4 md:space-y-6">
          {/* API 配置 */}
          <div className="card-gradient rounded-xl shadow-soft border border-gray-100 p-4 md:p-6 hover-lift animate-fade-in-up">
            <h2 className="text-base md:text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <span className="text-xl">🔌</span>
              API 配置
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  API 地址
                </label>
                <input
                  type="text"
                  value={settings.apiUrl}
                  onChange={(e) => setSettings({ ...settings, apiUrl: e.target.value })}
                  className="w-full px-4 py-2 rounded-lg border border-gray-200 bg-gray-50/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm transition-all duration-300 hover:border-primary-300"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  同步间隔（分钟）
                </label>
                <input
                  type="number"
                  value={settings.syncInterval}
                  onChange={(e) => setSettings({ ...settings, syncInterval: Number(e.target.value) })}
                  className="w-full px-4 py-2 rounded-lg border border-gray-200 bg-gray-50/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm transition-all duration-300 hover:border-primary-300"
                />
              </div>
            </div>
          </div>

          {/* 功能开关 */}
          <div className="card-gradient rounded-xl shadow-soft border border-gray-100 p-4 md:p-6 hover-lift animate-fade-in-up animate-delay-100">
            <h2 className="text-base md:text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <span className="text-xl">⚙️</span>
              功能设置
            </h2>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0 pr-4">
                  <p className="font-medium text-gray-900 text-sm md:text-base">自动同步</p>
                  <p className="text-xs md:text-sm text-gray-500">定期自动同步数据</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    checked={settings.autoSync}
                    onChange={(e) => setSettings({ ...settings, autoSync: e.target.checked })}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
                </label>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0 pr-4">
                  <p className="font-medium text-gray-900 text-sm md:text-base">深色模式</p>
                  <p className="text-xs md:text-sm text-gray-500">使用深色主题界面</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    checked={settings.darkMode}
                    onChange={(e) => setSettings({ ...settings, darkMode: e.target.checked })}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all after:duration-300 peer-checked:bg-gradient-to-r peer-checked:from-primary-600 peer-checked:to-primary-700 hover:shadow-soft"></div>
                </label>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0 pr-4">
                  <p className="font-medium text-gray-900 text-sm md:text-base">消息通知</p>
                  <p className="text-xs md:text-sm text-gray-500">接收系统消息和提醒</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    checked={settings.notifications}
                    onChange={(e) => setSettings({ ...settings, notifications: e.target.checked })}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all after:duration-300 peer-checked:bg-gradient-to-r peer-checked:from-primary-600 peer-checked:to-primary-700 hover:shadow-soft"></div>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* 侧边栏 */}
        <div className="space-y-4 md:space-y-6">
          {/* 保存按钮 */}
          <div className="bg-white rounded-xl shadow-sm p-4 md:p-6">
            <Button onClick={handleSave} className="w-full">
              💾 保存设置
            </Button>
            <p className="text-xs text-gray-500 mt-3 text-center">
              上次保存: 2024-12-12 10:30
            </p>
          </div>

          {/* 危险操作 */}
          <div className="bg-white rounded-xl shadow-sm p-4 md:p-6">
            <h2 className="text-base md:text-lg font-semibold text-red-600 mb-4">危险操作</h2>
            <div className="space-y-3">
              <Button variant="danger" className="w-full text-sm">
                🗑️ 清空所有数据
              </Button>
              <Button variant="ghost" className="w-full text-sm text-red-600 hover:bg-red-50">
                🔄 重置设置
              </Button>
            </div>
          </div>

          {/* 关于 */}
          <div className="bg-white rounded-xl shadow-sm p-4 md:p-6">
            <h2 className="text-base md:text-lg font-semibold text-gray-900 mb-4">关于</h2>
            <div className="text-sm text-gray-600 space-y-2">
              <p>版本: v0.0.1</p>
              <p>构建时间: 2024-12-12</p>
              <a href="#" className="text-primary-600 hover:underline block">
                查看更新日志
              </a>
              <a href="#" className="text-primary-600 hover:underline block">
                问题反馈
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
